import { render, staticRenderFns } from "./HomeScreenWarningModal.vue?vue&type=template&id=e2ea5120&"
import script from "./HomeScreenWarningModal.vue?vue&type=script&lang=ts&"
export * from "./HomeScreenWarningModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports